// extracted by mini-css-extract-plugin
export default {"menu":"style_menu__OtdMM","hide":"style_hide__86hrr"};